/**
 * Where a charger is, in words. Most organisations have one site, so the site's name only
 * shows once its organisation has two or more; until then the organisation is enough.
 */
export function placeOf(c: { siteName: string | null; organisationName: string | null; organisationSiteCount?: number }, withOrganisation = false): string {
  if (!c.siteName) return c.organisationName ?? '';
  if ((c.organisationSiteCount ?? 2) <= 1) return c.organisationName ?? c.siteName;
  return withOrganisation && c.organisationName ? `${c.siteName} · ${c.organisationName}` : c.siteName;
}

/** Labels for a list of sites: the organisation alone where it has one site. */
export function siteLabels<T extends { id: string; name: string; organisationId: string; organisationName: string }>(sites: T[], withOrganisation: boolean): Map<string, string> {
  const perOrg = new Map<string, number>();
  for (const s of sites) perOrg.set(s.organisationId, (perOrg.get(s.organisationId) ?? 0) + 1);
  return new Map(
    sites.map((s) => [s.id, placeOf({ siteName: s.name, organisationName: s.organisationName, organisationSiteCount: perOrg.get(s.organisationId) }, withOrganisation)]),
  );
}
